<template>
  <div>
    <div>
      <div class="flex2">
        <div class="flex2">
          <div class="fixed_width72">提交时间：</div>
          <Date-picker
            type="datetimerange"
            split-panels
            placeholder="选择日期"
            :value="filterCondition.createDate"
            style="width: 300px; margin-right: 34px; height: 32px"
            :editable="false"
            @on-change="createDateChange"
          ></Date-picker>
        </div>

        <div class="flex2">
          <div class="fixed_width72">患者姓名：</div>
          <input
            type="text"
            v-model="filterCondition.name"
            style="width: 180px"
          />
        </div>

        <div class="flex2">
          <label for="inquiry_recording" class="fixed_width72"
            >问诊方式：</label
          >
          <select
            id="inquiry_recording"
            class="select_inquiry_recording"
            v-model="filterCondition.selectModel"
            style="width: 180px"
          >
            <option>全部</option>
            <option>图文问诊</option>
            <option>视频问诊</option>
          </select>
        </div>
      </div>

      <div class="flex2 margin_top26 margin_bottom26">
        <div class="flex2" v-if="totalShop">
          <div class="fixed_width72">来源门店：</div>
          <!-- <input type="text" v-model="filterCondition.sourceName" style="width:180px;" /> -->
          <select
            id="inquiry_recording"
            class="select_inquiry_recording"
            v-model="filterCondition.ShopId"
            style="width: 180px"
          >
            <option value="0">全部</option>
            <option
              :value="item.ShopId"
              v-for="(item, i) in childStoreList"
              :key="i"
            >
              {{ item.ShopName }}
            </option>
          </select>
        </div>
        <div class="fixed_width72">手机号：</div>
        <input
          type="tel"
          maxlength="11"
          v-model="filterCondition.mobile"
          style="width: 180px"
        />

        <div class="flex2" v-if="totalShop">
          <label for="inquiry_recording" class="fixed_width72">状态：</label>
          <select
            id="inquiry_recording"
            class="select_inquiry_recording"
            v-model="filterCondition.prescriptionStatus"
            style="width: 180px"
          >
            <option>全部</option>
            <option>等待接诊</option>
            <option>接诊中</option>
            <option>已开方</option>
            <option>已拒绝</option>
          </select>
        </div>
        <div
          class="inquiry_recording_search_btn pointer"
          @click="filterSearchInquiry"
        >
          查询
        </div>
        <div
          class="inquiry_recording_search_btn pointer"
          style="margin-left: 15px;"
          @click="handleExport"
        >
          导出
        </div>
      </div>
      <Table
        :columns="tableColumns"
        :data="tableData"
        border
        style="margin-bottom: 20px"
      ></Table>
      <Page
        :total="PageTotal"
        :current="page"
        style="text-align: center"
        show-total
        show-elevator
        @on-change="pageChange"
      />
    </div>
  </div>
</template>
<script>
import { GetInquiryList, CreateDownLoadInq, DownLoadOrderList } from "@/utils/api.js";
import { getToken, getAge } from "@/utils/common.js";
import lookPrescription from "@/components/lookPrescription";
import oneSignature from "@/components/onekeySignature";
import { Radio, Alert, Divider, Toast } from "iview";
import axios from "axios";
import dayjs from "dayjs";
export default {
  props: {
    childStoreList: {
      default: false,
    },
  },
  data() {
    return {
      filterCondition: {
        // 筛选条件
        selectModel: "全部",
        createDate: ["", ""],
        name: "",
        mobile: "",
        ShopId: "0",
        prescriptionStatus: "全部",
      },
      tableColumns: [
        {
          title: "问诊编号",
          key: "LoInquiryId",
          align: "center",
          width: 150
        },
        {
          title: "提交时间",
          key: "createTime",
          align: "center",
          width: 150,
          render: (h, params) => {
            return h("span", this.formatDateTime(params.row.createTime));
          },
        },
        {
          title: "患者姓名",
          key: "name",
          align: "center",
        },
        {
          title: "性别",
          key: "sex",
          align: "center",
        },
        {
          title: "年龄",
          key: "Birthday",
          align: "center",
          render: (h, params) => {
            var str = params.row.Birthday;
            var strs = str.split("T")[0];
            var bathstr = getAge(strs);

            return h("span", bathstr);
          },
        },
        {
          title: "手机号",
          key: "mobile",
          align: "center",
        },
        {
          title: "问诊方式",
          key: "type",
          align: "center",
        },
        {
          title: "状态",
          key: "status",
          align: "center",
          render: (h, params) => {
            let tmpStr = "";
            if (params.row.status == "已拒绝") {
              tmpStr = "已拒绝";
            } else if (params.row.status == "等待接诊") {
              tmpStr = "等待接诊";
            } else if (params.row.status == "接诊中") {
              tmpStr = "接诊中";
            } else if (params.row.status == "已开方") {
              tmpStr = "已开方";
            }
            return h(
              "span",
              {
                style: {
                  color:
                    params.row.status == "已拒绝"
                      ? "#DB0E0E"
                      : params.row.status == "等待接诊"
                      ? "#2F318B"
                      : params.row.status == "已开方"
                      ? "#4BB150"
                      : "#ff9900",
                },
              },
              tmpStr
            );
          },
        },
        {
          title: "操作",
          key: "doit",
          align: "center",
          render: (h, params) => {
            console.log(h);
            console.log(params);
            if (params.row.inqStatus == 1) {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    on: {
                      click: () => {
                        this.$emit("clickInquiryDetail", params.row);
                      },
                    },
                  },
                  "问诊详情"
                ),
              ]);
            } else if (params.row.inqStatus == 3) {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    on: {
                      click: () => {
                        this.$emit("clickInquiryDetail", params.row);
                      },
                    },
                  },
                  "问诊详情"
                ),
              ]);
            } else if (params.row.inqStatus == 5) {
              //连锁门店的问诊记录隐藏续方操作！
              if (
                this.shopType == 0 &&
                this.shopName !== params.row.CompanyName
              ) {
                return h("div", [
                  h(
                    "Button",
                    {
                      props: {
                        type: "text",
                        size: "small",
                      },
                      on: {
                        click: () => {
                          this.$emit("clickInquiryDetail", params.row);
                        },
                      },
                    },
                    "问诊详情"
                  ),
                  h(
                    "Button",
                    {
                      props: {
                        type: "text",
                        size: "small",
                      },
                      on: {
                        click: () => {
                          this.$emit("clickSeePrescription", params.row);
                        },
                      },
                    },
                    "查看处方"
                  ),
                ]);
              } else {
                return h("div", [
                  h(
                    "Button",
                    {
                      props: {
                        type: "text",
                        size: "small",
                      },
                      on: {
                        click: () => {
                          this.$emit("clickInquiryDetail", params.row);
                        },
                      },
                    },
                    "问诊详情"
                  ),
                  h(
                    "Button",
                    {
                      props: {
                        type: "text",
                        size: "small",
                      },
                      on: {
                        click: () => {
                          this.$emit("clickSeePrescription", params.row);
                        },
                      },
                    },
                    "查看处方"
                  ),
                  // h(
                  //   "Button",
                  //   {
                  //     props: {
                  //       type: "text",
                  //       size: "small",
                  //     },
                  //     on: {
                  //       click: () => {
                  //         this.$emit("clickKeep", params.row);
                  //       },
                  //     },
                  //   },
                  //   "续方"
                  // ),
                ]);
              }
            } else if (params.row.inqStatus == 99) {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    on: {
                      click: () => {
                        this.$emit("clickInquiryDetail", params.row);
                      },
                    },
                  },
                  "问诊详情"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    on: {
                      click: () => {
                        this.$emit("clickRefuseResult", params.row);
                      },
                    },
                  },
                  "拒绝原因"
                ),
              ]);
            } else if (params.row.inqStatus == 9) {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    on: {
                      click: () => {
                        this.$emit("clickInquiryDetail", params.row);
                      },
                    },
                  },
                  "问诊详情"
                ),
              ]);
            }
          },
        },
      ],
      tableData: [],
      PageTotal: 0, //问诊记录总条数
      page: 1,
      shopType: "",
      totalShop: false, //访问的是连锁总部的时候显示的筛选条件
      DownLoadInqKey:"",
    };
  },
  methods: {
    // 点击问诊记录分页
    pageChange(i) {
      console.log(i);
      this.page = i;
      this.getInquiryList();
    },
    //提交时间的改变
    createDateChange(value) {
      if (value && value.length === 2 && value[0] && value[1]) {
        // 开始日期设置为 00:00:00
        const startDate = value[0];
        // 结束日期设置为 23:59:59
        let endDate = value[1];
        if (value[1].includes("00:00:00")) {
          endDate = dayjs(value[1])
            .endOf("day")
            .format("YYYY-MM-DD HH:mm:ss");
        }

        this.filterCondition.createDate = [startDate, endDate];
      } else {
        this.filterCondition.createDate = value;
      }
    },
    // 问诊列表条件筛选
    filterSearchInquiry() {
      this.page = 1;
      const msg = this.$Message.loading({
        content: "搜索中",
        duration: 0,
      });
      this.getInquiryList(msg);
    },
    //导出
    handleExport() {
      const msg = this.$Message.loading({
        content: "加载中",
        duration: 0,
      });
      let ModeType =
        this.filterCondition.selectModel == "全部"
          ? ""
          : this.filterCondition.selectModel == "视频问诊"
          ? 5
          : 1;
      let InquiryStatus =
        this.filterCondition.prescriptionStatus == "全部"
          ? ""
          : this.filterCondition.prescriptionStatus == "等待接诊"
          ? 1
          : this.filterCondition.prescriptionStatus == "接诊中"
          ? 3
          : this.filterCondition.prescriptionStatus == "已开方"
          ? 5
          : 99;
      var search = {
        StartTime: this.filterCondition.createDate[0], //提交开始时间 （可选）
        EndTime: this.filterCondition.createDate[1], //提交结束时间 （可选）
        Name: this.filterCondition.name, //患者姓名
        Mobilephone: this.filterCondition.mobile, //电话号码
        ShopId: this.filterCondition.ShopId, //来源门店
        Status: InquiryStatus, //状态 全部=="" , 等待接诊==1,接诊中==3,已开方==5,已拒绝==99
        DrugName: "", //药品名称
        ModeType, //问诊方式 全部=="",视频问诊==5，图文问诊==1]
      };
      CreateDownLoadInq(search).then((res) => {
        setTimeout(msg, 17);
        if (res.code == 1) {
          this.$Notice.warning({
            title: "提示",
            desc: "批量导出生成中",
          });
          this.DownLoadInqKey = res.data;
          this.loadingDownInq();
        } else {
          this.$Modal.warning({
            title: "提示",
            content: res.msg,
          });
        }
      });
    },
    loadingDownInq(){
      DownLoadOrderList({ DownLoadKey: this.DownLoadInqKey }).then((res) => {
        if (res.code == 1) {
          window.open(process.env.VUE_APP_RELOAD + res.data);
        } else {
          setTimeout(() => {
            this.loadingDownInq();
          }, 3000);
        }
      });
    },
    // 获取问诊列表
    getInquiryList(msg) {
      let ModeType =
        this.filterCondition.selectModel == "全部"
          ? ""
          : this.filterCondition.selectModel == "视频问诊"
          ? 5
          : 1;
      let InquiryStatus =
        this.filterCondition.prescriptionStatus == "全部"
          ? ""
          : this.filterCondition.prescriptionStatus == "等待接诊"
          ? 1
          : this.filterCondition.prescriptionStatus == "接诊中"
          ? 3
          : this.filterCondition.prescriptionStatus == "已开方"
          ? 5
          : 99;

      var search = {
        StartTime: this.filterCondition.createDate[0], //提交开始时间 （可选）
        EndTime: this.filterCondition.createDate[1], //提交结束时间 （可选）
        Name: this.filterCondition.name, //患者姓名
        Mobilephone: this.filterCondition.mobile, //电话号码
        ShopId: this.filterCondition.ShopId, //来源门店
        Status: InquiryStatus, //状态 全部=="" , 等待接诊==1,接诊中==3,已开方==5,已拒绝==99
        DrugName: "", //药品名称
        PageIndex: this.page,
        ModeType, //问诊方式 全部=="",视频问诊==5，图文问诊==1
        PageSize: 10,
      };
      GetInquiryList(search).then((res) => {
        if (msg) {
          setTimeout(msg, 17);
        }
        if (res.code == 1) {
          console.error(11111);
          this.tableData = []; //初始化
          this.PageTotal = res.data.total; //赋予总页数
          res.data.list.map((item) => {
            this.tableData.push({
              inqStatus: item.Status == 0 ? 1 : item.Status,
              DealDesc: item.DealDesc,
              createTime: item.CreateDate,
              CompanyName: item.ShopName,
              name: item.Name,
              sex: item.Sex == 1 ? "男" : "女",
              age: item.Age || "未填",
              Birthday: item.Birthday,
              mobile: item.Mobilephone,
              type: item.ModeType == 1 ? "图文问诊" : "视频问诊",
              InquiryId: item.InquiryId,
              LoInquiryId: item.LoInquiryId,
              status:
                item.Status == 1
                  ? "等待接诊"
                  : item.Status == 0
                  ? "等待接诊"
                  : item.Status == 3
                  ? "接诊中"
                  : item.Status == 5
                  ? "已开方"
                  : item.Status == 99
                  ? "已拒绝"
                  : item.Status == 9
                  ? "接诊中"
                  : "接诊中",
            });
          });
        } else {
          this.$Message.warning(res.msg);
        }
        this.loading = false;
      });
    },
    formatDateTime(dateString) {
      if (!dateString) return "";
      var date = new Date(dateString);
      var year = date.getFullYear();
      var month = (date.getMonth() + 1).toString().padStart(2, "0");
      var day = date
        .getDate()
        .toString()
        .padStart(2, "0");
      var hours = date
        .getHours()
        .toString()
        .padStart(2, "0");
      var minutes = date
        .getMinutes()
        .toString()
        .padStart(2, "0");
      var seconds = date
        .getSeconds()
        .toString()
        .padStart(2, "0");

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    //续方跳转回来刷新第一页
    handeGotoone() {
      this.page = 1;
      this.getInquiryList();
    },
  },

  mounted() {
    this.$bus.$on("handleInqEvent", this.handeGotoone);
    this.shopType = localStorage.getItem("extendType");
    this.shopName = localStorage.getItem("companyName");

    if (localStorage.getItem("extendType") == 0) {
      let comObg = {
        title: "来源门店",
        key: "CompanyName",
        align: "center",
      };
      this.totalShop = true;
      this.tableColumns.splice(6, 0, comObg);
    } else {
      this.tableColumns.map((item) => {
        if (item.title == "来源门店") {
          this.tableColumns.pop();
        }
      });
    }

    const myDate = new Date();
    const year = myDate.getFullYear(); // 获取当前年份
    const month =
      myDate.getMonth() + 1 < 10
        ? "0" + (myDate.getMonth() + 1)
        : myDate.getMonth() + 1; // 获取当前月份(0-11,0代表1月所以要加1);
    const day =
      myDate.getDate() < 10 ? "0" + myDate.getDate() : myDate.getDate(); // 获取当前日（1-31）
    // 日期格式：2019/07/29 - 2019/07/29
    // const lastDate = new Date(new Date() - 6 * 24 * 60 * 60 * 1000);

    // const lastYear = lastDate.getFullYear(); // 获取当前年份
    // const lastMonth =
    //   lastDate.getMonth() + 1 < 10
    //     ? "0" + (lastDate.getMonth() + 1)
    //     : lastDate.getMonth() + 1; // 获取当前月份(0-11,0代表1月所以要加1);
    // const lastDay =
    //   lastDate.getDate() < 0 ? "0" + lastDate.getDate() : lastDate.getDate(); // 获取当前日（1-31）

    this.filterCondition.createDate = [
      `${year}-${month}-${day} 00:00:00`,
      `${year}-${month}-${day} 23:59:59`,
    ];
    this.getInquiryList();
  },
  created() {},
};
</script>
<style lang="scss" scoped src="../scss/index.scss"></style>
